/**
 * Falling crisps animation – crisps fall out of the bag with GSAP
 * Each crisp transforms (rotates, drifts) while falling
 */
(function () {
  const LOG = '[FallingCrisps]';
  const CHIP_URLS = [
    'https://cdn.shopify.com/s/files/1/0610/0179/3696/files/single_chip_testing_9e14b4f7-2e76-4504-87cf-ef0feff2b596.png?v=1771336760',
    'https://cdn.shopify.com/s/files/1/0610/0179/3696/files/4_5664e238-583f-44c4-975c-bf56c2487486.png?v=1773242429',
    'https://cdn.shopify.com/s/files/1/0610/0179/3696/files/10_7924b8d2-8c28-4141-bf92-cd6baa0c9afd.png?v=1773242429'
  ];
  const CHIP_COUNT = 12;
  const FALL_DURATION_MIN = 4.5;
  const FALL_DURATION_MAX = 6.5;
  const ROTATION_MIN = 360;
  const ROTATION_MAX = 1080;
  const SIZE_MIN = 120;
  const SIZE_MAX = 180;

  const container = document.getElementById('gewinnspiel-falling-crisps');
  if (!container) {
    console.warn(LOG, 'Container #gewinnspiel-falling-crisps not found');
    return;
  }
  console.log(LOG, 'Container found');

  function loadGsapAndStart(callback) {
    if (typeof gsap !== 'undefined') {
      console.log(LOG, 'GSAP loaded');
      callback();
      return;
    }
    var gsapSrc = container.dataset.gsapSrc;
    if (!gsapSrc) {
      console.error(LOG, 'GSAP not loaded and no fallback URL (data-gsap-src)');
      return;
    }
    console.log(LOG, 'Loading GSAP from theme asset...');
    var script = document.createElement('script');
    script.src = gsapSrc;
    script.async = false;
    script.onload = function () {
      console.log(LOG, 'GSAP loaded, starting animation');
      callback();
    };
    script.onerror = function () {
      console.error(LOG, 'Failed to load GSAP from theme asset.');
    };
    document.head.appendChild(script);
  }

  function startAnimation() {
    try {
      console.log(LOG, 'startAnimation called');
    } catch (e) {
      console.error(LOG, 'startAnimation error:', e);
    }

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function createCrisp() {
    const img = document.createElement('img');
    img.src = CHIP_URLS[Math.floor(Math.random() * CHIP_URLS.length)];
    img.alt = '';
    img.loading = 'lazy';
    img.className = 'gewinnspiel-falling-crisp';
    img.setAttribute('aria-hidden', 'true');
    return img;
  }

  function initCrisps() {
    container.innerHTML = '';
    const crisps = [];
    for (let i = 0; i < CHIP_COUNT; i++) {
      const crisp = createCrisp();
      container.appendChild(crisp);
      crisps.push(crisp);
    }
    console.log(LOG, 'initCrisps: created', crisps.length, 'crisps');
    return crisps;
  }

  function getContainerBounds() {
    var signupSection = document.getElementById('gewinnspiel-signup');
    var faqSection = document.getElementById('gewinnspiel-faq');
    var signupRect = signupSection ? signupSection.getBoundingClientRect() : container.getBoundingClientRect();
    var faqRect = faqSection ? faqSection.getBoundingClientRect() : signupRect;
    var height = faqRect.bottom - signupRect.top;
    return { width: signupRect.width, height: Math.max(height, signupRect.height) };
  }

  function fallCrisp(crisp) {
    crisp.src = CHIP_URLS[Math.floor(Math.random() * CHIP_URLS.length)];
    var bounds = getContainerBounds();
    var sectionWidth = bounds.width;
    var sectionHeight = bounds.height;

    container.style.height = sectionHeight + 'px';

    var fallDistance = sectionHeight + 50;
    var startX = sectionWidth * 0.08 + randomBetween(-30, 30);
    var startY = randomBetween(-20, 20);

    const size = randomBetween(SIZE_MIN, SIZE_MAX);
    if (!crisp.dataset.fallLogged) {
      crisp.dataset.fallLogged = '1';
      console.log(LOG, 'fallCrisp: section', sectionWidth.toFixed(0), 'x', sectionHeight.toFixed(0));
    }
    const driftX = randomBetween(-80, 80);
    const duration = randomBetween(FALL_DURATION_MIN, FALL_DURATION_MAX);
    const rotation = randomBetween(ROTATION_MIN, ROTATION_MAX) * (Math.random() > 0.5 ? 1 : -1);
    const delay = randomBetween(0, 1.2);

    gsap.set(crisp, {
      position: 'absolute',
      left: startX,
      top: startY,
      width: size,
      height: 'auto',
      x: '-50%',
      y: 0,
      rotation: 0,
      opacity: 1,
      zIndex: 9999,
      pointerEvents: 'none',
      visibility: 'visible'
    });

    gsap.to(crisp, {
      y: fallDistance,
      x: `+=${driftX}`,
      rotation: rotation,
      opacity: 1,
      duration: duration,
      delay: delay,
      ease: 'power1.in',
      onComplete: function () {
        crisp.style.visibility = 'hidden';
        setTimeout(function () {
          fallCrisp(crisp);
        }, 300);
      }
    });
  }

  function animateCrisps(crisps) {
    crisps.forEach(function (crisp) {
      fallCrisp(crisp);
    });
  }

  const crisps = initCrisps();
  console.log(LOG, 'animateCrisps: starting', crisps.length, 'crisps');
  animateCrisps(crisps);
  }

  function init() {
    loadGsapAndStart(startAnimation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
